import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { DealerMessageModel, ProductModel } from './shop.model';
import { environment } from '../../../environments/environment';
import { sortBy } from 'lodash';

@Injectable()

export class ShopService {
  constructor(
    private http: HttpClient
  ) {}

  public getProducts(params?: any): Observable<any> {
    let _shopParams = new HttpParams();
    Object.keys(params).forEach((key) => {
      if (params[key] !== undefined && params[key] !== null && key !== 'productID') {
        _shopParams = _shopParams.append(key, params[key]);
      }
    });

    return this.http.get<any>(environment.apiUrl + '/product', {params: _shopParams}).map((response) => {
      if (response.Form) {
        response.Form = this.sortForm(response.Form);
      }
      return response;
    });
  }

  public updateProducts(param?: string): Observable<any> {
    const _param = (param) ? '?' + param : '';
    return this.http.get<any>(environment.apiUrl + '/product' + _param).map((response) => {
      if (response.Form) {
        response.Form = this.sortForm(response.Form);
      }
      return response;
    });
  }

  public getProductDetail(id: string): Observable<any> {
    if (id && id.length > 0 ) {
      return this.http.get<ProductModel>(environment.apiUrl + '/product/' + id);
    } else {
      return Observable.create(false);
    }
  }

  public getSlideshow(): Observable<any> {
    return this.http.get(environment.apiUrl + '/content/slideshow');
  }

  public postDealerMessage(dealerMessage: DealerMessageModel): Observable<any> {
    if (dealerMessage && Object.keys(dealerMessage).length > 0 ) {
      return this.http.post(environment.apiUrl + '/contact', dealerMessage);
    } else {
      return Observable.create(false);
    }
  }

  private sortForm(form: any): any {
    if (form && Object.keys(form).length > 0) {
      Object.keys(form).forEach((filter) => {
        if (filter === 'Dealer' || filter === 'Model') {
          form[filter].options = sortBy(form[filter].options, [(option) => option.description.toLowerCase()]);
        } else if (filter !== 'PriceRange' && filter !== 'Sorting') {
          if (form[filter].options && form[filter].options.length > 0) {
            form[filter].options = sortBy(form[filter].options, [(option) => {if (option.value) { return parseInt(option.value); }}]);
          }
        }
      });
    }

    return form;
  }
}




// WEBPACK FOOTER //
// /var/jenkins_home/workspace/leolux-dealer-outlet-frontend/checkout/src/app/components/shop/shop.service.ts